import { Card, Container, Stack, Typography } from "@mui/material";
import { Game, postStat } from "../Game.helpers"
import { useEffect, useState } from "react";
import EndScreen from "./EndScreen";
import useIsMobile from '../App.helper';

export interface GamePlayProps{
    games:Game[]
}

const GamePlay = (props:GamePlayProps)=> {
    const [randomGames, setRandomGames] = useState<Game[]>()
    const [score, setScore] = useState<number>(0)
    const [game1time, setGame1Time] = useState<number[]|null>([0,0])
    const [game2time, setGame2Time] = useState<number[]|null>([0,0])
    const [roundResult, setRoundResult] = useState<'INCORRECT'|'CORRECT'|null>(null)
    const [gameState, setGameState] = useState<string>('PLAYING')
    const [round, setRound] = useState<number>(1)
     const isMobile = useIsMobile()

    const getRandomGames = ()=>{
        const gameArray:Game[] = []
        while (gameArray.length<2){
            const potentialGame = props.games[Math.floor(Math.random() * props.games.length)];
            if (
                gameArray.filter((g) => g.n === potentialGame.n || g.m === potentialGame.m).length === 0 ) {
                gameArray.push(potentialGame);
            }
        }

        if (gameArray[0].m === gameArray[1].m) {
            getRandomGames();
            return;
        }
        setRandomGames(gameArray)
    }

    useEffect(()=>{
        getRandomGames()
    },[])

   useEffect(()=>{
        if(round===10){setGameState('END_GAME')}
    },[round])

    const handleSelection = (game:number) => {

        if(gameState==='NEXT_ROUND') {
            setGameState('PLAYING')
            setRoundResult(null)
            setGame1Time(null)
            setGame2Time(null)
            getRandomGames()
            let roundNumber = round
            setRound(roundNumber+1)
            return
        }
        // get next games
        if(!randomGames) return
        let correct = randomGames[0].m > randomGames[1].m ? 1 : 2;
        setGame1Time(getHoursAndMinutes(randomGames[0].m))
        setGame2Time(getHoursAndMinutes(randomGames[1].m))

        postStat({ correct: game === correct });
        
        if(game === correct){
            const newScore = score+1
            setScore(newScore)
            setRoundResult('CORRECT')
        } else {
            const newScore = score-1
            setScore(newScore)
            setRoundResult('INCORRECT')
        }
        setGameState('NEXT_ROUND')
    }


    const getHoursAndMinutes = (minutes:number)=> {
        let hours = Math.floor(minutes / 60);
        minutes = minutes - hours * 60;
        return [hours, minutes];
    }

    const handleNewGame = () =>{
        setGameState('PLAYING')
        setRoundResult(null)
        setGame1Time(null)
        setGame2Time(null)
        setRound(1)
        setScore(0)

        getRandomGames()
    }

    return ( gameState !== 'END_GAME' ? <Container>
    <Typography variant={!isMobile ? 'h4':'h5'} marginBottom={'1rem'}>Which has been played more?</Typography>
    <Stack direction='row' justifyContent={'space-between'}>
        <Typography>Round: {round}/10</Typography>
        <Typography>Your Score: {score}</Typography>
    </Stack>
    
    <Stack direction={!isMobile ?"row":'column'} justifyContent={'space-between'}>
        {randomGames && <><Card sx={{width:!isMobile ? '47.5%':'100%', height:'20rem'}} onClick={()=>{handleSelection(1)}}>
            <img
        src={`https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/${randomGames[0].i}/header.jpg`}
        className="card-img-top"
        alt={`${randomGames[0].n}`}
    />
            <Typography>{randomGames[0].n}</Typography>
            {(game1time && game1time[0] !== 0 && game1time[1]!== 0 )&&<Typography>{game1time[0]} hours and {game1time[1]} minutes</Typography>}
        </Card>

        <Card sx={{width:!isMobile ? '47.5%':'100%',height:'20rem'}} onClick={()=>{handleSelection(2)}}> 
                <img
        src={`https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/${randomGames[1].i}/header.jpg`}
        className="card-img-top"
        alt={`${randomGames[1].n}`}
    />
            <Typography>{randomGames[1].n}</Typography>
                {game2time && game2time[0] !== 0 && game2time[1]!== 0 && <Typography>{game2time[0]} hours and {game2time[1]} minutes</Typography>}
        </Card>
       </>
         
        }
    </Stack>
    <Stack height={'3rem'}> 
        {roundResult === 'CORRECT' && <Typography>🔥 Congrats! You chose the correct game! 🔥</Typography>}
        {roundResult === 'INCORRECT' && <Typography>❌ Oops! Wrong choice. Better luck next time. ❌</Typography>}
    </Stack>
    </Container> : <EndScreen score={score} newGame={()=>handleNewGame()}></EndScreen>   
)
}


export default GamePlay;